import { ApprovalCountsEntity } from "../entities/ApprovalEntity";
import { ApprovalRepository } from "../repositories/ApprovalRepository";

/**
 * Get Approval Counts Use Case
 * Fetches counts of approvals grouped by entity type and status
 */
export class GetApprovalCountsUseCase {
  constructor(private repository: ApprovalRepository) {}

  async execute(): Promise<ApprovalCountsEntity> {
    return await this.repository.getCounts();
  }
}
